export default __webpack_public_path__ + "static/media/intellectures.png.webp";